import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import CampaignMonitoringPanel from '../../components/marketing/CampaignMonitoringPanel';
import AdminCampaignPerformancePage from './AdminCampaignPerformancePage';
export default function AdminCampaignsPage() {
  const history = useLocation().pathname.endsWith('/historico');
  return <section><h1 className="h3">Campanhas</h1><p className="text-muted">Acompanhe a operação e o desempenho das clínicas.</p>
    <nav className="nav nav-tabs mb-4" aria-label="Seções de campanhas"><NavLink end to="/admin/campanhas" className="nav-link">Monitoramento</NavLink><NavLink to="/admin/campanhas/historico" className="nav-link">Histórico de desempenho</NavLink></nav>
    {history ? <AdminCampaignPerformancePage /> : <CampaignMonitoringPanel admin />}
  </section>;
}
